import React, { useContext } from 'react';
import { Header, Divider, List } from 'semantic-ui-react';
import MarkdownField from '../../../../../../components/MarkdownContent';
import { MenuItemVariationPropType } from '../../../../../../services/proptypes';
import { MenuContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { ModifierSetsBasic } from '../../modifiers';
import ItemInteraction from '../ItemInteraction';
import ItemVariations from '../ItemVariations';
import './ItemBasic.css';
var defaultProps = {
  description: null,
  className: '',
  variations: []
};
export default function ItemBasic(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    variations = _ref.variations,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useContext = useContext(MenuContext),
    items = _useContext.items,
    modifierSets = _useContext.modifierSets,
    disableModifiers = _useContext.disableModifiers,
    precision = _useContext.precision,
    displayZeroCostItemPrices = _useContext.displayZeroCostItemPrices,
    displayZeroCostModifierPrices = _useContext.displayZeroCostModifierPrices;
  var item = MenuUtil.getItemById(items, id);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  return /*#__PURE__*/React.createElement(List.Item, {
    onClick: onClick,
    className: "item-basic ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-text"
  }, name), /*#__PURE__*/React.createElement(ItemInteraction, {
    item: item
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      flexGrow: 1,
      margin: '1rem 0.5rem 0 0.5rem'
    }
  }), /*#__PURE__*/React.createElement(ItemVariations, {
    variations: variations,
    precision: precision,
    displayZeroCostItemPrices: displayZeroCostItemPrices
  })), /*#__PURE__*/React.createElement(MarkdownField, {
    style: {
      marginBottom: '0.25rem'
    },
    className: "markdown"
  }, description), !disableModifiers && /*#__PURE__*/React.createElement(ModifierSetsBasic, {
    modifierSets: itemModifierSets,
    displayZeroCostModifierPrices: displayZeroCostModifierPrices
  }));
}
ItemBasic.defaultProps = defaultProps;